import React from 'react';

import { LoaderSpinnerProps } from './Interfaces';
import { LoaderSpinner } from './LoaderSpinner';
import styled from 'styled-components';
import { Property } from 'csstype';

type LoaderOpacityOptions = {
  color?: string;
  opacity?: Property.Opacity;
};

type LoaderContainerProps = LoaderSpinnerProps & {
  loading?: boolean;
  opacity?: LoaderOpacityOptions;
  children: React.ReactNode;
};

export const LoaderContainer = (props: LoaderContainerProps) => {
  const { children, loading, opacity, ...innerProps } = props;
  return (
    <LoaderContainerStyled>
      {loading && (
        <>
          {opacity && (
            <LoaderOpacity opacity={opacity.opacity} color={opacity.color} />
          )}
          <LoaderSpinner {...innerProps} absolute />
        </>
      )}
      {children}
    </LoaderContainerStyled>
  );
};

const LoaderContainerStyled = styled.div<LoaderSpinnerProps>`
  position: relative;
`;

const LoaderOpacity = styled.div<LoaderOpacityOptions>`
  position: absolute;
  width: 100%;
  height: 100%;
  ${({ color }) => color && `background-color: ${color}`};
  ${({ opacity }) => opacity && `opacity: ${opacity}`};
  z-index: 2;
`;
